import { useEffect, useState } from 'react';
import { getDesignLibraryElementNode, } from '../components/BKJSelect/utils/getDesignLibraryElementNode.js';
export const usePortalTargetElement = (id) => {
    const [targetElement, setTargetElement] = useState(getDesignLibraryElementNode(id));
    useEffect(() => {
        if (!targetElement) {
            const element = document.createElement('div');
            element.setAttribute('id', id);
            document.body.prepend(element);
            setTargetElement(element);
        }
    }, []); // eslint-disable-line
    return targetElement;
};
//# sourceMappingURL=usePortalTargetElement.js.map